import { INSTAGRAM_PLACEHOLDERS_BASE_PATH } from '@zyro-inc/cdn-builder-placeholders/constants';

export const INSTAGRAM_MEDIA_PLACEHOLDERS = [
	{
		alt: 'Workstation',
		id: 'qc2YaEHSYsc',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/workstation.jpg`,
	},
	{
		alt: 'Waterfall between rocks',
		id: 'ifnzcFXUmH0',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/waterfall-between-rocks.jpg`,
	},
	{
		alt: 'Trees with snow',
		id: 'J2vryWaTqlB',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/trees-with-snow.png`,
	},
	{
		alt: 'Tree buds',
		id: 'ZzmFPZuw7S1',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/tree-buds.jpg`,
	},
	{
		alt: 'Tiger drinking water',
		id: 'k37Jfax7a6k',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/tiger-drinking-water.jpg`,
	},
	{
		alt: 'Tall well preserved buildings',
		id: 'gTNSQDsXWp7',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/tall-well-preserved-buildings.jpg`,
	},
	{
		alt: 'Sunny beautiful wall',
		id: 'QEdmdqjqcMf',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/sunny-beautiful-wall.jpg`,
	},
	{
		alt: 'Stereo gear',
		id: 'iUXujDl2onh',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/stereo-gear.jpg`,
	},
	{
		alt: 'Rooftop oasis',
		id: 'LWHjQE4HOv7',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/rooftop-oasis.jpg`,
	},
	{
		alt: 'Rocky beach',
		id: 'o4qz1QOQcpJ',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/rocky-beach.jpg`,
	},
	{
		alt: 'Photographer holding camera',
		id: 'VAHQ4wGABhK',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/photographer-holding-camera.jpg`,
	},
	{
		alt: 'Koi fishes',
		id: 'zg35JVHQ4wG',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/koi-fishes.jpg`,
	},
	{
		alt: 'Human head artificially created',
		id: 'zg35JVl8GY2',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/human-head-artificially-created.jpg`,
	},
	{
		alt: 'Horse eating grass',
		id: 'dBwJoATZJBH',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/horse-eating-grass.jpg`,
	},
	{
		alt: 'Fluffy decoration in water',
		id: 'HR21NDsphkV',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/fluffy-docoration-in-water.jpg`,
	},
	{
		alt: 'Elk looking at camera',
		id: 'oLq0J4X2h2P',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/elk-looking-at-camera.jpg`,
	},
	{
		alt: 'Dog running in snow',
		id: 'dbULY2RIxXc',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/dog-running-in-snow.jpg`,
	},
	{
		alt: 'Clean workspace',
		id: 'WRmXHA1JA8H',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/clean-workspace.jpg`,
	},
	{
		alt: 'Cinematic food shot',
		id: 'YgbHW4EtzbY',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/cinematic-food-shot.jpg`,
	},
	{
		alt: 'Christmas houses',
		id: 'Eyoj1y8hvYz',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/christmas-houses.jpg`,
	},
	{
		alt: 'Bird sitting on branch',
		id: 'yQKxjLtI8eg',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/bird-sitting-on-branch.jpg`,
	},
	{
		alt: 'Beautiful entry to private property',
		id: '1StnvFtqFjR',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/beautiful-entry-to-private-property.jpg`,
	},
	{
		alt: 'African animals',
		id: 'nPjqWNmfFf0',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/african-animals.jpg`,
	},
	{
		alt: 'Workspace',
		id: '7gsm5H6lHSH',
		src: `${INSTAGRAM_PLACEHOLDERS_BASE_PATH}/workspace.jpg`,
	},
];
